export interface RealtimeCollaborationProjectLike {
  orgId?: string | null;
  ownerType?: 'user' | 'org' | string | null;
  viewScope?: 'internal' | 'external' | string | null;
  collabDirection?: 'outgoing' | 'incoming' | string | null;
  type?: 'mine' | 'collab' | string | null;
}

export function isRealtimeCollaborationProject(
  project: RealtimeCollaborationProjectLike | null | undefined
): boolean {
  if (!project) return false;
  return Boolean(
    project.orgId ||
    project.ownerType === 'org' ||
    project.viewScope === 'external' ||
    project.collabDirection ||
    project.type === 'collab'
  );
}
